import CryptoJS from "crypto-js";
// This Function is called when gp call is being saved
//After combing the multiple status code returning the one status code
// This Status code functionality is based on the customer portal
export const getOrderStatusDetails = (statusCode) => {
    let SuccessfulCallOrderStatus = [1001, 1002, 1004, 2004, 3007]
    let TrashCallOrderStatus = [1005, 1007, 2001, 2002, 2003, 2005, 2006, 3004, 3005, 3008, 3009, 3010,]

    let notAnOrderCallStatus = [1003, 2007, 3006]

    if (SuccessfulCallOrderStatus.includes(Number(statusCode))) {
        //Ai Successful order
        return {
            OrderStatus: Number(statusCode),
            OrderConfirmed: 1,
            updateCallStatus: "REVIEW_DONE",
        };
    } else if (TrashCallOrderStatus.includes(Number(statusCode))) {
        //For Trash call
        return {
            OrderStatus: Number(statusCode),
            OrderConfirmed: 0,
            updateCallStatus: "TRASH",
        };
    }


    else if (notAnOrderCallStatus.includes(Number(statusCode))) {
        // To move in not an order Call
        return {
            OrderStatus: Number(statusCode),
            OrderConfirmed: 0,
            updateCallStatus: "REVIEW_DONE",
        };
    }


};



export const cardiacDiagnosisList = [{ value: "ECG", type: "ECG" }, { value: "ECHOCARDIOGRAM", type: "Echocardiogram" }, { value: "STRESS ECHOCARDIOGRAM", type: "Stress Echocardiogram" }, { value: "HOLTER", type: "Holter monitoring" }, { value: "AMBULATORY BLOOD PRESSURE", type: "Ambulatory Blood Pressure" }]

//For these keys , we will show the doctor list
export const GpServicesToShowDoctorList = ["DOCTOR_NEW_APPT", "BLOOD_OR_ALLERGY_TEST"]


//NOTE:- GP WorkFlow State
export const insuranceTypeList = [
    {
        type: "Medicare ",
        value: "MEDICARE",
    },
    {
        type: "Private Health Insurance ",
        value: "PVT_INSURANCE",
    },
    {
        type: "Cash",
        value: "CASH",
    },
];

export const error_codes = [{ label: "No response from server", value: "NO_RESPONSE_FROM_SERVER" }, { label: "Escalated Call", value: "ESCALATED" }, { label: "Pending Reconciliation", value: "PANDING_MANUAL_ORDER" }, { label: "Completed Reconciliation", value: "SUCCESSFUL_MANUAL_ORDER" }]
export const SuccessfulCallOrderStatus = [1001, 1002, 1004, 2004, 3007];

export const e5fbad38af8ba59c2648e98b9ae4196dfcb9f719 = "F30sTip28w#y5DinIx8xOtiJ3w3st5sWUstoC7sO7a1to7icEki3IQisTeswugow";
export const D33e100601bdf9512bdb7d13f5272efb6c90f5a93 = (text) => {
    if (process.env.NODE_ENV === "production" && text !== '') {
        const bytes = CryptoJS.AES.decrypt(text, e5fbad38af8ba59c2648e98b9ae4196dfcb9f719);
        const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return data;
    }
    else {
        return text;
    }
}
//
export const API_URL = D33e100601bdf9512bdb7d13f5272efb6c90f5a93(process.env.NODE_ENV === "production"?window.env.bc7c960:window.env.API_URL);
export const WS_URL = D33e100601bdf9512bdb7d13f5272efb6c90f5a93(process.env.NODE_ENV === "production"?window.env.bc7c960:window.env.API_URL).replace("http", "ws");
export const AUTH0_DOMAIN_NAME = D33e100601bdf9512bdb7d13f5272efb6c90f5a93(process.env.NODE_ENV === "production"?window.env.de70618:window.env.AUTH0_DOMAIN_NAME);
export const AUTH0_APP_CLIENT_ID = D33e100601bdf9512bdb7d13f5272efb6c90f5a93(process.env.NODE_ENV === "production"?window.env.de1a87b:window.env.AUTH0_APP_CLIENT_ID);
export const SESSION_MANAGER_API_URL = D33e100601bdf9512bdb7d13f5272efb6c90f5a93(process.env.NODE_ENV === "production"?window.env.e3j9o6:window.env.SESSION_MANAGER_API_URL);
export const AUTH0_APP_AUDIENCE = "https://" + AUTH0_DOMAIN_NAME + "/api/v2/";


export const WORKFLOW_FILTER = window.env.WORKFLOW_FILTER;

export const WORKDESK_CALL_NUMBER_LIMIT = 50
export const CALLHISTORY_CALL_NUMBER_LIMIT = 100

export const CONNECTION_STATUS = { CONNECTED: "CONNECTED", CONNECTING: "CONNECTING", DISCONNECTED: "DISCONNECTED" };

export const AUTH0_SCOPE = "read:current_user";



export const timeSlotList = ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18']

export const timeSlotsDict = [{}]

export const RELOAD_CONVERSATION_WORKFLOW = window.env.RELOAD_CONVERSATION_WORKFLOW;
export const makeTimeSlotDict = (data) => {
    //   let data =[
    //   {date: "2023-01-06",
    //   is_available: true,
    //   modality: "US",
    //   room_name: "US1",
    //   roster_text: "FRIDAY",
    //   schedule: "2023-01-06T08:00:00",
    //   slot_text: "FRIDAY",
    //   time: "08:00:00"
    // },
    // {date: "2023-01-06",
    //   is_available: true,
    //   modality: "US",
    //   room_name: "US1",
    //   roster_text: "FRIDAY",
    //   schedule: "2023-01-06T08:30:00",
    //   slot_text: "FRIDAY",
    //   time: "08:00:00"
    // },{date: "2023-01-06",
    // is_available: true,
    // modality: "US",
    // room_name: "US1",
    // roster_text: "FRIDAY",
    // schedule: "2023-01-06T08:50:00",
    // slot_text: "FRIDAY",
    // time: "08:00:00"
    // },
    // {date: "2023-01-06",
    //   is_available: true,
    //   modality: "US",
    //   room_name: "US1",
    //   roster_text: "FRIDAY",
    //   schedule: "2023-01-06T09:00:00",
    //   slot_text: "FRIDAY",
    //   time: "09:00:00"
    // },
    // {date: "2023-01-06",
    //   is_available: true,
    //   modality: "US",
    //   room_name: "US1",
    //   roster_text: "FRIDAY",
    //   schedule: "2023-01-06T09:20:00",
    //   slot_text: "FRIDAY",
    //   time: "09:20:00"
    // },
    // {date: "2023-01-06",
    //   is_available: true,
    //   modality: "US",
    //   room_name: "US1",
    //   roster_text: "FRIDAY",
    //   schedule: "2023-01-06T09:50:00",
    //   slot_text: "FRIDAY",
    //   time: "09:50:00"
    // },
    // {date: "2023-01-06",
    //   is_available: true,
    //   modality: "US",
    //   room_name: "US1",
    //   roster_text: "FRIDAY",
    //   schedule: "2023-01-06T010:00:00",
    //   slot_text: "FRIDAY",
    //   time: "10:00:00"
    // },
    // {date: "2023-01-06",
    //   is_available: true,
    //   modality: "US",
    //   room_name: "US1",
    //   roster_text: "FRIDAY",
    //   schedule: "2023-01-06T011:00:00",
    //   slot_text: "FRIDAY",
    //   time: "11:00:00"
    // },
    // {date: "2023-01-06",
    //   is_available: true,
    //   modality: "US",
    //   room_name: "US1",
    //   roster_text: "FRIDAY",
    //   schedule: "2023-01-06T014:00:00",
    //   slot_text: "FRIDAY",
    //   time: "14:00:00"
    // }
    // ]
    let timeSlotDict = [
        { time_range: "8-10", slots: [] },
        { time_range: "10-12", slots: [] },
        { time_range: "12-14", slots: [] },
        { time_range: "14-16", slots: [] },
        { time_range: "16-18", slots: [] },
        // {time_range:"13-14",slots:[]},{time_range:"14-15",slots:[]},
        // {time_range:"15-16",slots:[]},{time_range:"16-17",slots:[]},{time_range:"17-18",slots:[]},{time_range:"18-19",slots:[]}

    ]

    for (let i = 0; i < data.length; i++) {
        let time = data[i].time.split(":")

        if (time[0] === '08' || time[0] === '09') {
            let slot = timeSlotDict[0].slots
            slot = [...slot, data[i]]
            timeSlotDict[0].slots = slot

        } else if (time[0] === '10' || time[0] === '11') {
            let slot = timeSlotDict[1].slots
            slot = [...slot, data[i]]
            timeSlotDict[1].slots = slot

        } else if (time[0] === '12' || time[0] === '13') {
            let slot = timeSlotDict[2].slots
            slot = [...slot, data[i]]
            timeSlotDict[2].slots = slot

        } else if (time[0] === '14' || time[0] === '15') {
            let slot = timeSlotDict[3].slots
            slot = [...slot, data[i]]
            timeSlotDict[3].slots = slot

        } else if (time[0] === '16' || time[0] === '17') {
            let slot = timeSlotDict[4].slots
            slot = [...slot, data[i]]
            timeSlotDict[4].slots = slot

        } else if (time[0] === '17' || time[0] === '18') {
            let slot = timeSlotDict[5].slots
            slot = [...slot, data[i]]
            timeSlotDict[5].slots = slot

        }
    }

    return timeSlotDict

}



export const callSourceData = [{ text: "Referres", value: "Referres" }, { text: "Patient", value: "Patient" }, { text: "MISC", value: "MISC" }]

export const referrCallContextData = [{ text: "Patient Report", value: "Patient Report" }, { text: "MISC", value: "MISC" }]

export const patientCallContextData = [{ text: "Referral", value: "Referral" }, { text: "MISC", value: "MISC" }]

export const workflowTypes = [
    {
        appointment_type: "IMAGING_APPT",
        workflow_type: "IMAGING_WORKFLOW"
    },
    {
        appointment_type: "GP_APPT",
        workflow_type: "GP_WORKFLOW"
    }]